import {Component, OnInit} from '@angular/core';;
import {LocalStorageService} from './share/localstorage.service';
import {Router} from '@angular/router';
import {SyncService} from './share/sync.service';



@Component({
    selector: 'app-root',
    template: `
        @if (KeinInternet) {
          <div class="btn btn-danger" style="width:100%">
            Keine Internetverbindung
          </div>
        }
        
        @if (App_installiert == false) {
          <div class="btn btn-danger" style="width:100%;">
            <br><br><br>
            <h1><u><b>Bitte vor der Registrierung die App installieren!!</b></u></h1> <br><br><br>
          </div>
        }
        <router-outlet></router-outlet>
        `,
    providers: [
        SyncService
    ],
    standalone: false
})
export class AppComponent implements OnInit {
    public authenticated: boolean = false;
    private Interval = null;
    public KeinInternet = false;
    private KeinInternetCounter = 0;
    public App_installiert = true;


    constructor(private ls: LocalStorageService,
                private sync: SyncService,
                private SyncService: SyncService,
                private _router: Router) {}


    ngOnInit() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            if (!window.matchMedia('(display-mode: standalone)').matches) {
               // this.App_installiert = false;
            };
        }





        const link = document.createElement ('link');
        link.setAttribute ('rel', 'apple-touch-icon');
        const meta = document.createElement ('meta');
        meta.setAttribute ('name', 'apple-mobile-web-app-title');
        link.setAttribute ('href', './assets/images/apple-touch-icon.png');
        meta.setAttribute ('content', 'Feuerwehr APP');

        document.title = 'Feuerwehr APP';
        document.head.appendChild(link);
        document.head.appendChild (meta);


        this.ls.store ('APP_Ueberschrift', 'Feuerwehr App');









        /* Check Device registred and authentificated */
        console.log('TODO: Check auch noch online');
        if (!this.checkDeviceAuthentificated()) {
            console.log('Gerät ist nicht authentifiziert!');
            this._router.navigate(['registrieren']);
            return;
        }
        this.authenticated = true;



    /*
        if (this.ls.get('User_Key') !== undefined && this.ls.get('User_Key') !== null && this.ls.get('User_Key') !== '' && this.ls.get('User_Key') !== 'LEER') {
            setTimeout(() => {

                if (this.ls.get_FahrzeugeItems() == null) {this.sync.getData('fahrzeuge', 'force');}

                this.sync.getData();

            }, 1500);    // Mal erhöht von 500 auf 1500 am 04.11.2021 - da bei mir mit dem Hintergrundsync abundzu das kam
            this.Interval = setInterval(() => {
                this.sync.getData();
            }, 2500);
        }

*/
        this.sync.LoadingActive.subscribe((value: String) => {
             //console.log(value, this.KeinInternetCounter, this.KeinInternet);


            if (value === 'true') {
                this.KeinInternetCounter++;
            } else {
                this.KeinInternetCounter = 0;
            }

            if (this.KeinInternetCounter > 2) {
                this.KeinInternet = true;
                this.sync.setInternet(false);
            } else {
                this.KeinInternet = false;
                this.sync.setInternet(true);
            }
        });

    }

    checkDeviceAuthentificated(){
        if (!localStorage.getItem('MachineId')) { // Wenn MaschinenID nicht vorhanden
            console.log('MachineId fehlt');
            this.getMachineId();
            return false;
        }
        if (!localStorage.getItem('AuthentificationKey')) { // Wenn AuthentificationKey nicht vorhanden
            console.log('AuthentificationKey fehlt');
            return false;
        }
        return true;
    }

    getMachineId() {  // Random Maschinen ID entweder aus speicher oder erzeugen und speichern
        let machineId = localStorage.getItem('MachineId');
        if (!machineId) {
            machineId = crypto.randomUUID();
            localStorage.setItem('MachineId', machineId);
        }
        return machineId;
    }

}

